import { render, staticRenderFns } from "./SelectActiveModal.vue?vue&type=template&id=4c3fd4d9&"
import script from "./SelectActiveModal.vue?vue&type=script&lang=js&"
export * from "./SelectActiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3fd4d9')) {
      api.createRecord('4c3fd4d9', component.options)
    } else {
      api.reload('4c3fd4d9', component.options)
    }
    module.hot.accept("./SelectActiveModal.vue?vue&type=template&id=4c3fd4d9&", function () {
      api.rerender('4c3fd4d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/SelectActiveModal.vue"
export default component.exports